"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
/**
 * Close button for modal and dialog
 */
const CloseIconButton = ({ onClose }) => {
    return ((0, jsx_runtime_1.jsx)(IconButton_1.default, { "aria-label": "close", "data-testid": "dialog-close-button", onClick: onClose, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.CloseIconThin, { size: 24 }) }));
};
exports.default = CloseIconButton;
//# sourceMappingURL=CloseIconButton.js.map